export default location.search
  .replace(/^\?/, '')
  .split('&')
  .reduce((obj, current) => {
    const arr = current.split('=');
    if (arr[0]) obj[arr[0]] = decodeURIComponent(arr[1]);
    return obj;
  }, {});
